import { jsx as _jsx } from "react/jsx-runtime";
import CloseIcon from "@diligentcorp/atlas-react-icons/Close.js";
import { applyTokens } from "../../../utilities/applyTokens.js";
const getChipTokens = (tokens) => {
    return {
        chip: tokens.component.chip,
        statusIndicator: tokens.component.statusIndicator,
        semantic: tokens.semantic,
    };
};
const chip = (tokens) => {
    const { chip, semantic, statusIndicator } = getChipTokens(tokens);
    return {
        MuiChip: {
            defaultProps: {
                deleteIcon: _jsx(CloseIcon, {}),
            },
            styleOverrides: {
                root: ({ ownerState }) => (Object.assign({}, ((ownerState === null || ownerState === void 0 ? void 0 : ownerState.variant) !== "statusIndicator" && Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, applyTokens(chip)), applyTokens(chip.default)), { borderColor: "transparent" }), ((ownerState === null || ownerState === void 0 ? void 0 : ownerState.disabled) && Object.assign({}, applyTokens(chip.disabled)))), { "&:hover": Object.assign(Object.assign({}, applyTokens(chip.hover)), ((ownerState === null || ownerState === void 0 ? void 0 : ownerState.disabled) && {
                        cursor: "default",
                    })), "&.Mui-disabled": Object.assign(Object.assign({ opacity: 1 }, applyTokens(chip.disabled)), { ".MuiChip-deleteIcon": {
                            color: chip.disabled.color.value,
                            ":hover": {
                                cursor: "default",
                                color: chip.disabled.color.value,
                            },
                        } }) })))),
                avatar: ({ ownerState }) => (Object.assign(Object.assign({}, applyTokens(chip.avatar)), { marginLeft: (ownerState === null || ownerState === void 0 ? void 0 : ownerState.variant) === "outlined"
                        ? `calc(-1 * ${semantic.spacing.default.value} - ${chip.borderWidth.value})`
                        : `calc(-1 * ${semantic.spacing.default.value})` })),
                outlined: Object.assign(Object.assign({}, applyTokens(chip.default)), { backgroundColor: "transparent", "&.MuiChip-clickable": {
                        "&:hover": {
                            backgroundColor: chip.hover.backgroundColor.value,
                        },
                    } }),
                statusIndicator: ({ ownerState }) => (Object.assign(Object.assign({}, applyTokens(statusIndicator)), (((ownerState === null || ownerState === void 0 ? void 0 : ownerState.color) === "disabled" || (ownerState === null || ownerState === void 0 ? void 0 : ownerState.disabled)) && Object.assign({}, applyTokens(statusIndicator.color.disabled))))),
                label: {
                    height: "auto",
                    paddingLeft: 0,
                    paddingRight: 0,
                },
                deletable: {
                    paddingRight: 0,
                    ".MuiChip-deleteIcon": Object.assign(Object.assign({}, applyTokens(chip.icon)), { flexShrink: 0, marginLeft: 0, ":hover": {
                            color: chip.icon.color.value,
                        } }),
                    "&:focus": {
                        boxShadow: semantic.shadow.focus.value.stringValue,
                    },
                },
                deletableColorDisabled: {
                    ":hover": {
                        backgroundColor: chip.disabled.backgroundColor.value,
                    },
                    ".MuiChip-deleteIcon": {
                        color: chip.disabled.color.value,
                        ":hover": {
                            cursor: "default",
                            color: chip.disabled.color.value,
                        },
                    },
                },
                clickable: {
                    "&:focus": {
                        boxShadow: semantic.shadow.focus.value.stringValue,
                    },
                },
            },
        },
    };
};
export default chip;
//# sourceMappingURL=chip.js.map